<template>
  <v-container fluid>
    <v-layout row>
      <v-flex xs12 lg4 offset-lg4>
        <v-card class="pa-0">
          <v-card-title primary-title>
            <img src="@/assets/logo-erling.png" id="logo" v-if="config.OWNER === 'erling'" />
            <img src="@/assets/logo-ragnvald.png" id="logo" style="max-width: 400px; margin: 0 auto;" v-else-if="config.OWNER === 'ragnvald'" />
            <div v-else>Ugyldig OWNER</div>
          </v-card-title>
          <v-card-text>
            <v-progress-linear v-if="isSubmitting" :indeterminate="true"></v-progress-linear>
            <notifications group="login" key="login" />

            <v-form>
              <v-text-field
                prepend-icon="person"
                v-model="email"
                label="Din e-post"
                :disabled="isSubmitting"
                @keyup.enter="login"
                required
              ></v-text-field>

              <v-text-field
                prepend-icon="lock"
                v-model="password"
                label="Passord"
                type="password"
                :disabled="isSubmitting"
                @keyup.enter="login"
                required
              ></v-text-field>

              <v-card-actions>
                <v-btn
                  color="green darken-1"
                  dark
                  @click.native="login"
                >Login</v-btn>
                <v-spacer />
                <v-btn @click.native="openDialog()" flat>Glemt passord?</v-btn>
              </v-card-actions>
            </v-form>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
    <forgot-password-dialog :state="dialogState"
      @resetPassword="onResetPassword"
      @close="onCloseDialog"
    />
  </v-container>
</template>

<script>
import AuthenticationService from '@/services/AuthenticationService'
import ForgotPasswordDialog from '@/components/ForgotPasswordDialog'

export default {
  name: 'login',
  data () {
    return {
      email: '',
      password: '',
      isSubmitting: false,
      dialogState: {
        open: false
      }
    }
  },
  methods: {
    async login () {
      this.consumeNotifications()

      if (this.email.length * this.password.length === 0) {
        this.addNotification(true, {
          group: 'login',
          type: 'error',
          text: 'Fyll inn både kundenummer og passord.'
        })
        return
      }

      const response = await this.runService(this, 'login', AuthenticationService.login, {
        email: this.email,
        password: this.password
      })

      if (response) {
        this.$store.dispatch('setToken', response.data.token)
        this.$store.dispatch('setCustomers', response.data.customers)
        this.$store.dispatch('setAcceptedTerms', response.data.acceptedTerms)
        this.$store.dispatch('setShowMultipleUsersSnackbar', response.data.customers.length > 1)
        this.$store.dispatch('setCustomer', response.data.customers[0])
        this.$router.push({ name: 'my-services' })
      }
    },
    openDialog () {
      this.dialogState.open = true
    },
    onResetPassword (email) {
      this.email = email
      this.password = ''

      this.addNotification(true, {
        group: 'login',
        type: 'info',
        text: 'Ditt passord har blitt nullstilt! Prøv å logg inn under.'
      })
    },
    onCloseDialog () {
      this.dialogState.open = false
    }
  },
  components: {
    ForgotPasswordDialog
  }
}
</script>

<style scoped>
#logo {
  width: 100%
}

.v-alert {
  padding: 0.7em;
  margin-bottom: 2em;
}
</style>
